import { useContext } from "react";
import { NonConflictingThemeContext } from "./NonConflictingThemeProvider.tsx";

export const useNonConflictingTheme = () => {
  const context = useContext(NonConflictingThemeContext);
  if (!context) {
    throw new Error(
      "useNonConflictingTheme must be used within NonConflictingThemeProvider",
    );
  }
  return context;
};
